import React from "react";
import { Description, SubTitle } from "../../../Components/CustomComponents";

const Header = ({ title, subTitle }) => {
  return (
    <div>
      <SubTitle text={title} classes="" />
      <Description text={subTitle} classes="text-muted" />
    </div>
  );
};

export default Header;
